module.exports = __webpack_public_path__ + "img/pic_cdzbn.718618ce.png";